// @flow
import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Widget from 'app/components/Widget';
import styles from './Quote.styles';

class Quote extends React.Component<Props> {
    render() {
      const {classes} = this.props;
      
      return (
        <Widget className={classes.wrapper}>
          <div className={classes.container}>
            <span className="icon-quotes-right"> </span>
            نیرو تو را فرا می&zwnj;خواند، بگذار وارد شود.
            <span className="author"> Star Wars: The Force Awakens (2015) </span>
          </div>
        </Widget>
      );
    }
}

const Component = withStyles(styles)(Quote);
export {Component as Quote};
export default Component;